export default "__VITE_ASSET__BvozlaA0__"